import * as React from 'react'

function SvgSoundOffButtonL(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 130 130" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M52.662 59.24h.166l.133-.099 10.934-8.174h0l.003-.002.01-.008.048-.033c.041-.029.102-.07.175-.115.15-.092.333-.193.503-.255a.926.926 0 01.191-.05.811.811 0 01.005.098v28.627c0 .157-.02.235-.034.271a.772.772 0 01-.265-.068 3.173 3.173 0 01-.58-.326 4.786 4.786 0 01-.255-.19l-.013-.01-.003-.002h0l-.01-.009-.012-.008-10.698-7.939-.133-.098H47.5V59.24h5.162zm12.149-8.794l.005.011-.005-.01zm-.03 29.08s.001-.004.007-.01c-.004.008-.007.01-.007.01z"
        fill="#000"
        stroke="#000"
      />
      <line x1={73.185} y1={61.795} x2={82.386} y2={70.997} stroke="#000" strokeWidth={2} strokeLinecap="round" />
      <line x1={72.95} y1={70.997} x2={82.152} y2={61.796} stroke="#000" strokeWidth={2} strokeLinecap="round" />
      <rect x={0.5} y={0.5} width={129} height={129} rx={64.5} stroke="#000" />
    </svg>
  )
}

export default SvgSoundOffButtonL
